import {Box, Dialog, DialogContent, LinearProgress, Typography} from "@mui/material";
import {translateKey} from "utils/fieldsFormatters";
import { lazy, Suspense, use } from "react";
import {LanguageContext} from "context/LanguageContext";

const DialogTitleWithCloseIcon = lazy(() => import("./DialogTitleWithCloseIcon"));

interface InfoDialogProps {
    title: string
    subtitle?: string
    items: string[]
    open: boolean
    onClose: () => void
}

const InfoDialog = ({title, subtitle, items, open, onClose}: InfoDialogProps) => {
    const {language} = use(LanguageContext);

    return <Dialog open={open} onClose={onClose} fullWidth
                   maxWidth={'xs'}>

        <Suspense fallback={<Box sx={{width: '100%'}}>
            <LinearProgress/>
        </Box>}><DialogTitleWithCloseIcon title={translateKey(title, language)} subtitle={subtitle} onClose={onClose}/></Suspense>
        <DialogContent>
            <Typography>
                <ul>{items.map(item => <li key={item}>{item}</li>)}</ul>
            </Typography>
        </DialogContent>
    </Dialog>
}

export default InfoDialog